// extracted by mini-css-extract-plugin
var _1 = "MainMenu_mainMenuContainer__u8sFI";
export { _1 as "mainMenuContainer" }
